import { Scenarios } from '@jfs/network'

const userAuthenticate = {
  default: [
    {
      url: /user\/authenticate/,
      method: 'POST',
      body: /REQUEST/,
      response: {
        status: 'SUCCESS',
        data: {
          bankCustomerId: 56954336,
          authorizationCode: 'a82162c0-21fc-41e9-80c0-9e90e8fa37a5',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /user\/authenticate/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '33607', message: 'INVALID' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { userAuthenticate }
